import {
	ARTIST_DISPLAY_THRESHOLD,
	HIDDEN_ARTIST_ROLE_IDS,
	type IArtworkMinimum,
} from '@metmuseum/types';
import { useTranslations } from 'next-intl';

export const ArtistCultureDisplayer = ({
	object,
	culture,
	threshold = ARTIST_DISPLAY_THRESHOLD,
}: IProps) => {
	const t = useTranslations('collection');

	// Use detailed artist data if available
	if (object.artists && object.artists.length > 0) {
		if (object.artists.length > threshold) {
			return t('multipleArtistsMakers');
		}

		// Artists are already ordered by the API
		return (
			<>
				{object.artists.map(({ role, prefix, displayName, roleID }) => {
					const showRole = !HIDDEN_ARTIST_ROLE_IDS.includes(roleID);
					const text = [showRole && role, prefix, displayName]
						.filter(Boolean)
						.join(' ');

					return <div key={text}>{text}</div>;
				})}
			</>
		);
	}

	// Fallback to simple artist names
	const allArtistsDeDuped = [
		...new Set([object?.primaryArtist, ...(object.allArtistsFormatted || [])]),
	].filter(Boolean); // because our data is beautiful, but not perfect

	if (allArtistsDeDuped?.length > threshold) {
		return t('multipleArtistsMakers');
	}
	if (allArtistsDeDuped?.length > 0) {
		return allArtistsDeDuped?.map((artist) => <div key={artist}>{artist}</div>);
	}
	if (object.primaryArtist) {
		return object.primaryArtist;
	}
	// Final fallback to culture
	if (culture || object.culture) {
		const cultureValue = culture || object.culture;
		return cultureValue;
	}
};

export interface IProps {
	object: IArtworkMinimum;
	culture?: string;
	threshold?: number;
}
